import * as Yup from 'yup';

export const initialValues = {
  reason: '',
};

export const validationSchema = Yup.object().shape({
  reason: Yup.string().required('Reason is required'),
});
